import { render, staticRenderFns } from "./tecnicoForm.vue?vue&type=template&id=e5495fa4&scoped=true&"
import script from "./tecnicoForm.vue?vue&type=script&lang=js&"
export * from "./tecnicoForm.vue?vue&type=script&lang=js&"
import style0 from "./tecnicoForm.vue?vue&type=style&index=0&id=e5495fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5495fa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VSwitch,VTextField})
